import ProductGuideline from '@/components/docPageComponents/product-guideline';
import AllProductIcon from '@/components/SvgIcon/icons/AllProductIcon';
import { Popover } from 'antd';
import { getOrderedProductWithType } from '@/components/docPageComponents/utils';
import { groupBy } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import Styles from './index.module.scss';
import { ProductInfo } from '@/services/document';

type ProductGuideLinePopoverProps = {
  productList: ProductInfo[];
  cmsConfig: {
    hotSearchKeys: string[];
    productTypeOrder: string[];
  };
};

const ProductGuideLinePopover = (props: ProductGuideLinePopoverProps) => {
  const { productList, cmsConfig } = props;
  const [guidelineData, setGuideLineData] = useState([]);
  const iconRef = useRef(null);

  const getProductGuidelines = async () => {
    const productListByType = groupBy(productList, 'firstType');
    const res = getOrderedProductWithType(
      cmsConfig?.productTypeOrder,
      productListByType
    );
    setGuideLineData(res);
  };

  useEffect(() => {
    getProductGuidelines();
  }, []);

  const title = () => {
    return (
      <div style={{ minWidth: guidelineData.length * 215 }}>
        <ProductGuideline data={guidelineData} layout="horizontal" />
      </div>
    );
  };

  return (
    <>
      <Popover
        color="#FFFFFF"
        placement="bottomRight"
        content={title}
        getPopupContainer={() => iconRef.current}
        className={Styles.popoverContainer}
      >
        <span ref={iconRef}>
          <AllProductIcon />
        </span>
      </Popover>
    </>
  );
};

export default ProductGuideLinePopover;
